const getAuthPrefix = (endpoint: string) => `/auth/${endpoint}`;
const getUserPrefix = (endpoint: string) => `/user/${endpoint}`;
const getClientPrefix = (endpoint: string) => `/client/${endpoint}`;
const getCompanyPrefix = (endpoint: string) => `/company/${endpoint}`;
const getLeadPrefix = (endpoint: string) => `/lead/${endpoint}`;
const getLotPrefix = (endpoint: string) => `/lot/${endpoint}`;
const getProjectPrefix = (endpoint: string) => `/project/${endpoint}`;
const getPlaceTypePrefix = (endpoint: string) => `/place_type/${endpoint}`;
const getNoticePrefix = (endpoint: string) => `/notice/${endpoint}`;
const getWebPushPrefix = (endpoint: string) => `/webpush/${endpoint}`;
const getMeetingPrefix = (endpoint: string) => `/meeting/${endpoint}`;
const getReservationPrefix = (endpoint: string) => `/reservation/${endpoint}`;
const getSubAgentPrefix = (endpoint: string) => `/sub_agent/${endpoint}`;
const getIntegrationDadataPrefix = (endpoint: string) => `/integration/dadata/${endpoint}`;
const getAgreementPrefix = (endpoint: string) => `/agreement/${endpoint}`;
const getAccreditationPrefix = (endpoint: string) => `/accreditation/${endpoint}`;

export const ENDPOINTS = {
  auth: {
    login: getAuthPrefix('login'),
    register: getAuthPrefix('register'),
    recovery: getAuthPrefix('recovery'),
    logout: getAuthPrefix('logout'),
    setPassword: getAuthPrefix('set_password'),
  },
  user: {
    current: getUserPrefix('current'),
    profile: getUserPrefix('profile'),
    create: getUserPrefix('create'),
    edit: getUserPrefix('edit'),
    list: getUserPrefix('list'),
    get: (id: number) => getUserPrefix(`${id}`),
  },
  client: {
    leadList: getClientPrefix('lead_list'),
    get: (id: number) => getClientPrefix(`${id}`),
    list: getClientPrefix('list'),
    create: getClientPrefix('create'),
    edit: getClientPrefix('edit'),
    unique: getClientPrefix('unique'),
  },
  company: {
    update: (id: number) => getCompanyPrefix(`${id}`),
  },
  lead: {
    get: (id: number) => getLeadPrefix(`${id}`),
    list: getLeadPrefix('list'),
    create: getLeadPrefix('create'),
  },
  lot: {
    get: (id: number) => getLotPrefix(`${id}`),
    list: getLotPrefix('list'),
    filters: getLotPrefix('filters'),
    reservationInfo: (id: number) => getLotPrefix(`${id}/reservation_info`),
    reserve: (id: number) => getLotPrefix(`${id}/reserve`),
  },
  project: {
    list: getProjectPrefix('list'),
  },
  placeType: {
    list: getPlaceTypePrefix('list'),
  },
  notice: {
    list: getNoticePrefix('list'),
  },
  webPush: {
    getPublicKey: getWebPushPrefix('key'),
    subscribe: getWebPushPrefix('subscribe'),
    unsubscribe: getWebPushPrefix('unsubscribe'),
  },
  meeting: {
    get: (id: number) => getMeetingPrefix(`${id}`),
    list: getMeetingPrefix('list'),
    create: getMeetingPrefix('create'),
    edit: getMeetingPrefix('edit'),
    cancel: (id: number) => getMeetingPrefix(`cancel/${id}`),
    slots: getMeetingPrefix('slots'),
    update: (id: number) => getMeetingPrefix(`${id}`),
  },
  config: {
    get: () => '/config',
  },
  reservation: {
    list: getReservationPrefix('list'),
  },
  subAgent: {
    list: getSubAgentPrefix('list'),
    create: getSubAgentPrefix('create'),
  },
  integrationDadata: {
    ids: getIntegrationDadataPrefix('ids'),
  },
  agreement: {
    registration: getAgreementPrefix('registration'),
  },
  accreditation: {
    fields: getAccreditationPrefix('fields'),
  },
};
